import React from 'react';
import cn from 'clsx';
import {spacingsGenerator, textAlignGenerator, backgroundGenerator, textStylesGenerator} from '../util/styles';

type BoxProps = {
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    id?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    textAlign?: 'start' | 'center' | 'end';
}

const Box = React.forwardRef((props: BoxProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
        <div
            className={cn({
            ...spacingsGenerator(props),
            ...textAlignGenerator(props),
            ...backgroundGenerator(props),
            ...textStylesGenerator(props)
            }, props.className) || undefined}
            style={props.style}
            id={props.id}
            ref={ref}
            onClick={props.onClick}
        >
            {props.children}
        </div>
    )
});

export default Box;
